import styles from './orderActions.module.css';
import {useOrderStore} from '../../store/orderStore';
import {useState} from 'react';
import {useMenuStore} from '../../store/menuStore';
import {Button, Typography} from '@toppy-webshop/toppy-design-system';
import {Icons} from '@toppy-webshop/toppy-design-system';
import {useI18nContext} from '../../i18n/i18n-react';
import useEvent from '../../utils/events/useEvent';
import {OpenAfterSalesQuestionaireEvent} from '../species/zogefixt/QuestionaireModal';
import {featureFlag} from '../../utils/featureFlag';

interface OrderActionsProps {
    isMobilePopup?: boolean;
}

const OrderActions = ({isMobilePopup}: OrderActionsProps) => {
    const {LL} = useI18nContext();
    const [showRetourError, setShowRetourError] = useState(false);
    const toggleMenu = useMenuStore(state => state.toggleMenu);
    const order = useOrderStore(state => state.order);
    const dispatchOpenAfterSalesQuestionaire =
        useEvent<OpenAfterSalesQuestionaireEvent>('openAfterSalesQuestionaire');

    if (!order) return <></>;

    const scrollToStatus = () => {
        const statusContainer = document.getElementById('status-container');
        statusContainer?.scrollIntoView({behavior: 'smooth'});
        toggleMenu();
    };

    return (
        <div className={styles.wrapper}>
            {isMobilePopup && (
                <Button
                    label={LL.menu.viewStatus()}
                    onClick={scrollToStatus}
                    full={true}
                    type={'primary'}
                    leftIcon={Icons.TOPPY_BOX_SPEED}
                />
            )}
            {order.isComplete && (
                <Button
                    label={LL.menu.returnOrRepair()}
                    onClick={() =>
                        featureFlag('zo_gefixt')
                            ? dispatchOpenAfterSalesQuestionaire({})
                            : window.open('/retour')
                    }
                    full={true}
                    type={'outline'}
                />
            )}
            {!order.isComplete && (
                <Button
                    label={LL.menu.returnOrRepair()}
                    onClick={() => setShowRetourError(!showRetourError)}
                    full={true}
                    type={order.isComplete ? 'outline' : 'disabled'}
                />
            )}
            {showRetourError && (
                <div className={styles['error-message']}>
                    <Typography size={'xs'} type={'danger'}>
                        {LL.menu.returnNotPossible()}
                    </Typography>
                </div>
            )}

            <Button
                label={LL.menu.downloadInvoice()}
                onClick={() =>
                    window.open(
                        `/pdf/index/generate/type/invoice/ref/${order.invoiceUuid}?download`
                    )
                }
                full={true}
                type={order.isPaid ? 'outline' : 'disabled'}
                leftIcon={Icons.DOWNLOAD}
            />
            {!featureFlag('zo_gefixt') && (
                <Button
                    label={LL.menu.askQuestion()}
                    full={true}
                    onClick={() => window.open('/klantenservice')}
                    type={'primary'}
                    leftIcon={Icons.CHAT}
                />
            )}
            {featureFlag('zo_gefixt') && (
                <Button
                    label={LL.menu.askHelp()}
                    full={true}
                    onClick={() => dispatchOpenAfterSalesQuestionaire({})}
                    type={'primary'}
                    leftIcon={Icons.CHAT}
                />
            )}

            {isMobilePopup && (
                <Button
                    label={LL.menu.close()}
                    full={true}
                    onClick={toggleMenu}
                    rightIcon={Icons.CROSS}
                    type={'clear'}
                />
            )}
        </div>
    );
};

export default OrderActions;
